import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { ToDosState, toDosFeatureKey } from '../reducers/to-dos.reducer';
import * as toDosState from '../reducers/to-dos.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, ToDosState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee toDo SUB STATE
export const getToDosState = createSelector(getMainEmployeeState, state => state[toDosFeatureKey]);
//#endregion

//#region Employee toDo SUB STATE
export const getTodoRequest = createSelector(getToDosState, toDosState.getToDosRequest);
export const getTodoSuccess = createSelector(getToDosState, toDosState.getToDosResponse);
export const getTodoFailure = createSelector(getToDosState, toDosState.getToDosFailure);
//#endregion
